import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    OnInit,
} from "@angular/core";
import { SMSTemplate } from "../../../../../../utils/types/sms/sms-template.type";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { RecordAction } from "../../../../../../utils/enums/shared/enums";
import { TranslateService } from "@ngx-translate/core";
import { ShortCode } from "../../../../../../utils/types/shared/shortcode.type";
import { GruposService } from "../../../../../../services/groups/grupos.service";
import { Grupo } from "../../../../../../utils/types/groups/grupo.type";
import { SharedCatalogService } from "../../../../../../services/shared/sharedcatalog.service";
import { ObservableDataService } from "../../../../../../services/core/observable-data.service";

@Component({
    templateUrl: "./approval-workflow-form.component.html",
    styleUrl: "./approval-workflow-form.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [GruposService, SharedCatalogService],
})
export class ApprovalWorkflowFormComponent implements OnInit {
    public action: RecordAction;
    public recordAction = RecordAction;
    public title: string;
    public templateForm: FormGroup;
    public template: SMSTemplate = new SMSTemplate();
    public grupos: Grupo[] = [];
    public shortCodes: ShortCode[] = [];
    public hasURL: boolean = false;

    constructor(
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<ApprovalWorkflowFormComponent>,
        private readonly translateService: TranslateService,
        private readonly gruposService: GruposService,
        private readonly sharedCatalog: SharedCatalogService,
        private ods: ObservableDataService
    ) {}

    ngOnInit(): void {
        this.template = this.data.template;
        this.loadShortCodes();
        this.loadGrupos(this.template.shortCode);
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");

        this.title = this.translateService.instant("templateInfo");
        this.buildForm();
    }

    loadShortCodes() {
        const currentUser = this.ods.getLoggedUser();
        this.sharedCatalog
            .getShortcodesObjects(currentUser.companyId)
            .subscribe((resShort) => {
                this.shortCodes = resShort;
                this.templateForm.controls.shortCode.setValue(
                    this.template.shortCode
                );
            });
    }

    loadGrupos(event: ShortCode) {
        if (event === null) {
            return;
        }
        this.gruposService
            .getGroupByOperator(event.operator.id)
            .subscribe((res) => {
                this.grupos = res;
                this.templateForm.controls.groups.setValue(
                    this.template.groups
                );
            });
    }

    buildForm() {
        this.templateForm = this.fb.group({
            name: [
                { value: this.template.name, disabled: true },
                Validators.required,
            ],
            content: [
                { value: this.template.content, disabled: true },
                Validators.required,
            ],
            groups: [{ value: this.template.groups, disabled: true }],
            shortCode: [
                { value: this.template.shortCode, disabled: true },
                Validators.required,
            ],
            longUrl: [{ value: this.template.url_code, disabled: true }],
            service_type: [
                { value: this.template.service_type, disabled: true },
            ],
        });

        if (this.template.url_code !== "" && this.template.url_code !== null) {
            this.hasURL = true;
        }
    }

    compareFn(op1: any, op2: any) {
        if (!op2) {
            return;
        }
        return op1.id === op2.id;
    }

    hasUrl(event) {
        if (event.checked) {
            this.hasURL = true;
            this.templateForm.controls["longUrl"].setValue(
                this.template.url_code
            );
        } else {
            this.hasURL = false;
            this.templateForm.controls["longUrl"].setValue(null);
            this.templateForm.controls["longUrl"].updateValueAndValidity();
        }
    }

    close() {
        this.dialogRef.close();
    }
}
